import { useContext } from "react";
import { WorkspaceIdContext } from "./WorkspaceIdContext";

/**
 * Id of the tenant workspace, passed down via context by ViewWrapper (which
 * resolves it once with useTenantWorkspace and mounts the provider only once the
 * workspace is resolved: below it the value is ALREADY there on the first render).
 *
 * Deliberately WITHOUT a fallback to the platform hook: outside the provider it
 * returns undefined (and queries with `enabled: !!workspaceId` stay off) instead of
 * falling back to useCurrentWorkspace, which — besides the first render at null —
 * would return the workspace selected in the shell, NOT the tenant the app must
 * operate on.
 */
export const useWorkspaceId = (): string | undefined =>
    useContext(WorkspaceIdContext);
